import { render } from "./index.vue?vue&type=template&id=f20bb024"
import script from "./simple-popup.js?vue&type=script&lang=js"
export * from "./simple-popup.js?vue&type=script&lang=js"

import "./simple-popup.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__